import React from 'react';
import PropTypes from 'prop-types';
import { patientPropType } from 'Shared/types';
import Modal from 'react-bootstrap/Modal';
import PatientIdentityHeader from 'App/components/PatientProfile/components/PatientIdentityHeader/PatientIdentityHeader';
import PatientRecord from 'App/components/PatientProfile/components/PatientRecordModal/PatientRecord/PatientRecord';
import './PatientRecordModal.scss';

const PatientRecordModal = ({ show, onHide, patientData }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            scrollable
            backdrop="static"
            keyboard={false}
            aria-label="Patient record"
            className="patient-record-modal"
        >
            <Modal.Header closeButton>
                <PatientIdentityHeader patient={patientData} />
            </Modal.Header>
            <Modal.Body>
                <PatientRecord />
            </Modal.Body>
        </Modal>
    );
};

PatientRecordModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    patientData: patientPropType.isRequired,
};

export default PatientRecordModal;
